import { __extends } from "tslib";
import { NodeMaterialBlock } from '../nodeMaterialBlock';
import { NodeMaterialBlockConnectionPointTypes } from '../Enums/nodeMaterialBlockConnectionPointTypes';
import { NodeMaterialBlockTargets } from '../Enums/nodeMaterialBlockTargets';
import { _TypeStore } from '../../../Misc/typeStore';
/**
 * Block used to scale a vector by a float
 */

var ScaleBlock = function (_super) {
  __extends(ScaleBlock, _super);
  /**
   * Creates a new ScaleBlock
   * @param name defines the block name
   */


  function ScaleBlock(name) {
    var _this = _super.call(this, name, NodeMaterialBlockTargets.Neutral) || this;

    _this.registerInput("input", NodeMaterialBlockConnectionPointTypes.AutoDetect);

    _this.registerInput("factor", NodeMaterialBlockConnectionPointTypes.Float);

    _this.registerOutput("output", NodeMaterialBlockConnectionPointTypes.BasedOnInput);

    _this._outputs[0]._typeConnectionSource = _this._inputs[0];
    return _this;
  }
  /**
   * Gets the current class name
   * @returns the class name
   */


  ScaleBlock.prototype.getClassName = function () {
    return "ScaleBlock";
  };

  Object.defineProperty(ScaleBlock.prototype, "input", {
    /**
     * Gets the input component
     */
    get: function get() {
      return this._inputs[0];
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ScaleBlock.prototype, "factor", {
    /**
     * Gets the factor input component
     */
    get: function get() {
      return this._inputs[1];
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ScaleBlock.prototype, "output", {
    /**
     * Gets the output component
     */
    get: function get() {
      return this._outputs[0];
    },
    enumerable: false,
    configurable: true
  });

  ScaleBlock.prototype._buildBlock = function (state) {
    _super.prototype._buildBlock.call(this, state);

    var output = this._outputs[0];
    state.compilationString += this._declareOutput(output, state) + (" = " + this.input.associatedVariableName + " * " + this.factor.associatedVariableName + ";\r\n");
    return this;
  };

  return ScaleBlock;
}(NodeMaterialBlock);

export { ScaleBlock };
_TypeStore.RegisteredTypes["BABYLON.ScaleBlock"] = ScaleBlock;